import { IconButton, Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useTenantTranslation } from "hooks/formatters";
import { LabellingGuideDialog } from "./LabellingGuideDialog";
import { usePauseWhileOpen } from "components/scrapEyeDataDashboard/VideoPlayer/hooks/usePauseWhileOpen";

export const LabellingGuideButton = ({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  const { t } = useTenantTranslation();
  usePauseWhileOpen(open);

  return (
    <>
      <Tooltip title={t("labellingGuide")}>
        <IconButton
          onClick={() => {
            onOpenChange(true);
          }}
          size="small"
          color="primary"
          sx={{ ml: 1 }}
        >
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>
      <LabellingGuideDialog
        open={open}
        onClose={() => {
          onOpenChange(false);
        }}
      />
    </>
  );
};
